import { BirthdateInputUnionType } from '../../../common';

type FocusNextFieldArgsType = {
  inputType: BirthdateInputUnionType;
  monthInputRef: React.RefObject<HTMLInputElement | null>;
  yearInputRef: React.RefObject<HTMLInputElement | null>;
};

export const focusNextField = ({
  inputType,
  monthInputRef,
  yearInputRef,
}: FocusNextFieldArgsType): void => {
  switch (inputType) {
    case 'DAY':
      monthInputRef.current?.focus();
      break;
    case 'MONTH':
      yearInputRef.current?.focus();
      break;
    default:
      break;
  }
};
